import { snapshot } from 'valtio'
import { type AxiosError } from 'axios'
import { buildAxiosInstance, SOURCE_NAME } from '../../../../../shared/utils/apiUtils'
import { convertToCentValue } from '../../../../../shared/utils/formattingUtils'
import { recurringPaymentNewProxy } from '../recurringPaymentNewProxy'
import {
  RecurringPaymentNewProxyFormFieldNamesEnum
} from '../recurringPaymentNewProxyFormFieldNamesEnum'
import { GtagEvents, gtmTrackButtonPress } from '../../../../../shared/utils/gtmUtils'

interface Response {
  data: {
    recurringPayment: {
      id: string
    }
  } | null
  error: string | null
  errorCode: { description: string, merchantAction: string }
}

export async function executeAddNewRecurringConfiguration (): Promise<void> {
  try {
    gtmTrackButtonPress(GtagEvents.RECURRING_CONFIGURATION_SUBMIT)

    recurringPaymentNewProxy.apiCallAddNewRecurringConfiguration.loading = true
    recurringPaymentNewProxy.apiCallAddNewRecurringConfiguration.error = null
    const { form: { values }, customer, customerCard, stopOnError } = snapshot(recurringPaymentNewProxy)

    const sendReceipt = !!values.email

    const response = await buildAxiosInstance().post<Response>('/api/recurring_payments/create_cc', {
      addressOne: values[RecurringPaymentNewProxyFormFieldNamesEnum.StreetAddressOne] || null,
      addressTwo: values[RecurringPaymentNewProxyFormFieldNamesEnum.StreetAddressTwo] || null,
      amountCents: convertToCentValue(Number(values.amount), 'USD'),
      amountCurrencyType: 'USD',
      billingCycle: values[RecurringPaymentNewProxyFormFieldNamesEnum.BillingCycle],
      city: values[RecurringPaymentNewProxyFormFieldNamesEnum.City] || null,
      countryCode: values[RecurringPaymentNewProxyFormFieldNamesEnum.CountryCode] || 'US',
      customerCardId: customerCard?.id,
      customerId: customer?.id,
      email: sendReceipt ? values[RecurringPaymentNewProxyFormFieldNamesEnum.Email] : null,
      endDate: values[RecurringPaymentNewProxyFormFieldNamesEnum.EndDate] || null,
      invoiceNumber: values[RecurringPaymentNewProxyFormFieldNamesEnum.InvoiceNumber],
      nextPaymentDate: values[RecurringPaymentNewProxyFormFieldNamesEnum.StartDate],
      notes: values[RecurringPaymentNewProxyFormFieldNamesEnum.Notes],
      postalCode: values[RecurringPaymentNewProxyFormFieldNamesEnum.PostalCode] || null,
      sourceName: SOURCE_NAME,
      state: values[RecurringPaymentNewProxyFormFieldNamesEnum.State] || null,
      stopOnError
    })
    if (response.data.data) {
      recurringPaymentNewProxy.completed = true
      recurringPaymentNewProxy.lastTransactionId = response.data.data.recurringPayment.id
    } else {
      recurringPaymentNewProxy.apiCallAddNewRecurringConfiguration.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      recurringPaymentNewProxy.apiCallAddNewRecurringConfiguration.error = e.message
      recurringPaymentNewProxy.apiCallAddNewRecurringConfiguration.errorMessage = (e as AxiosError<Response>).response?.data.error
      recurringPaymentNewProxy.apiCallAddNewRecurringConfiguration.errorCode = (e as AxiosError<Response>).response?.data.errorCode
    }
  } finally {
    recurringPaymentNewProxy.apiCallAddNewRecurringConfiguration.loading = false
  }
}
